export default __webpack_public_path__ + "static/media/metal-reducer.b2cbd722.png";